import $ from "../../jquery_global";

$(function () {
  var $dateWrapper = $(".js-desired-start-date-wrapper");
  var $radios = $('input[name="users_profile_supplement_form[desired_start_type]"]');

  if ($dateWrapper.length === 0 || $radios.length === 0) {
    return;
  }

  function toggleStartDate() {
    var isCustom = $radios.filter('[value="custom"]').is(":checked");
    $dateWrapper.toggle(isCustom);
    if (!isCustom) {
      $dateWrapper.find("select").val("");
    }
  }

  toggleStartDate();
  $radios.on("change", toggleStartDate);
});
